import styled from 'styled-components';
import {getContrastWhiteBlack} from '../../utils/helpers';

export const StyledParentDiv = styled.div`
    cursor:pointer;
    border: solid 1px ${props => props.theme.borderColor};
    &:hover {
     .rectangle{
      background-color: ${props => props.theme.hoverColor};
      border: solid 1px ${props => props.theme.brandColor};
    }
      .iconIssue,
      .title,
      .description,
      .footer {
        color: ${props => getContrastWhiteBlack(props.theme.hoverColor)};
      }
    }`;


// WEBPACK FOOTER //
// ./components/ServiceCatalog/styledSC.js